import React, { memo } from 'react'
import _style from './style.module.scss'
import classnames from 'classnames'
import { IFieldItemProps } from './interface'

const FieldItem: React.FC<IFieldItemProps> = ({
  cls = '',
  labelCls = '',
  valueCls = '',
  label,
  value,
  required,
  showError = true,
  errorTip,
  errorTipCls = '',
  extra
}) => (
  <div className={classnames({ [_style.container]: true, [cls]: true })}>
    <div className={classnames({ [_style.field]: true })}>
      {!!label && (
        <div className={_style.labelWrapper}>
          <div className={classnames({ [_style.label]: !!label, [labelCls]: true })}>
            {label}
            {!!required && <span className={_style.requiredIcon}> *</span>}
          </div>
          {extra}
        </div>
      )}

      <div className={classnames({ [valueCls]: true })}>{value}</div>
    </div>
    {showError && !!errorTip && (
      <div className={_style.errorBox}>
        <div className={classnames({ [_style.errorTip]: true, [errorTipCls]: true })}>
          {errorTip}
        </div>
      </div>
    )}
  </div>
)

FieldItem.defaultProps = {}

export default memo(FieldItem)
